// Init git repo trong folder + tạo initial commit. Idempotent: skip nếu đã
// có commit. Default branch "main".
import { simpleGit } from "simple-git";

const INITIAL_COMMIT_MESSAGE = "chore: initial commit";

export async function createInitialGitCommit(folderPath: string): Promise<void> {
  const g = simpleGit({ baseDir: folderPath });

  // Init nếu chưa có .git.
  const isRepo = await g.checkIsRepo().catch(() => false);
  if (!isRepo) {
    await g.init();
  }

  // Đảm bảo branch hiện tại là main (đổi master → main nếu cần).
  // Một số git config user có init.defaultBranch=master.
  try {
    await g.branch(["-M", "main"]);
  } catch {
    // Repo trống chưa có commit nào — branch -M sẽ fail. Bỏ qua, commit
    // đầu tiên dưới đây sẽ tạo branch main qua HEAD ref.
  }

  // Stage all + commit. Nếu không có file (folder rỗng) thì commit empty để
  // submodule add có HEAD reference dùng.
  await g.add(".");
  const status = await g.status();
  const hasCommits = (await g.raw(["rev-list", "-n", "1", "--all"]).catch(() => "")).trim();
  if (hasCommits) return; // Đã có commit, skip.

  if (status.files.length === 0) {
    await g.commit(INITIAL_COMMIT_MESSAGE, undefined, { "--allow-empty": null });
  } else {
    await g.commit(INITIAL_COMMIT_MESSAGE);
  }
}
